/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { sizes } from '@smartsheet/lodestar-core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchWorkflowRun,
  workflowRunStepsIsLoadingSelector,
  workflowRunStepsHasErrorSelector,
  selectedRunIdSelector,
} from '../../../../../services/ducks/workflowRunDuck/workflowRunDuck';
import { LoadingState } from './LoadingState';
import { PanelHeader } from './PanelHeader';
import { RunState } from './RunState';
import { StepError } from './StepError';
import { Steps } from './Steps';

const headerStateStyle = css`
  padding-right: ${sizes.large}px;
`;

export const RunSteps = () => {
  const dispatch = useDispatch();
  const selectedRunId = useSelector(selectedRunIdSelector);
  const isLoading = useSelector(workflowRunStepsIsLoadingSelector);
  const hasError = useSelector(workflowRunStepsHasErrorSelector);

  useEffect(() => {
    if (selectedRunId !== undefined) {
      dispatch(fetchWorkflowRun());
    }
  }, [selectedRunId, dispatch]);

  if (hasError) {
    return <StepError />;
  }

  return (
    <React.Fragment>
      <div css={headerStateStyle}>
        <PanelHeader />
        <RunState />
      </div>
      {isLoading ? <LoadingState /> : <Steps />}
    </React.Fragment>
  );
};
